module.exports = __webpack_public_path__ + "static/media/cs.e424423f.png";